module.exports = __webpack_public_path__ + "static/media/profile-bg.fc226b57.png";